import { compact, flatMap, isBoolean, isFunction, isNil, sortBy, } from 'lodash-es';
export function intersperse(arr, v, makeLast = false) {
    return flatMap(arr, (x, i) => (i === 0 && !makeLast ? [x] : [x, v]));
}
export function collect(arr, f) {
    if (isNil(arr)) {
        return [];
    }
    const func = isFunction(f) ? f : (t) => t[f];
    const results = [];
    let i = 0;
    for (const el of arr) {
        const res = func(el, i++, arr);
        if (isBoolean(res)) {
            // type predicate case
            if (res)
                results.push(el);
        }
        else if (!isNil(res)) {
            results.push(res);
        }
    }
    return results;
}
export async function asyncCollect(arr, f) {
    if (isNil(arr)) {
        return [];
    }
    const promises = [];
    let i = 0;
    for (const el of arr) {
        const promise = f(el, i++, arr);
        if (promise) {
            promises.push(promise);
        }
    }
    const out = await Promise.all(promises);
    return compact(out);
}
export function collectMapValues(input, f) {
    if (isNil(input)) {
        return [];
    }
    const results = [];
    for (const [key, value] of Object.entries(input)) {
        const res = f(value, key, input);
        if (isNil(res)) {
            continue;
        }
        results.push(res);
    }
    return results;
}
export function groupBy(arr, f) {
    if (isNil(arr)) {
        return {};
    }
    const ret = {};
    for (const t of arr) {
        const key = f(t);
        const v = ret[key];
        if (v) {
            v.push(t);
        }
        else {
            ret[key] = [t];
        }
    }
    return ret;
}
export function rotateArray(arr, positions) {
    return arr.slice(positions, arr.length).concat(arr.slice(0, positions));
}
export function binarySearchRange(seq, target) {
    let low = 0, high = seq.length - 1;
    const sorted = sortBy(seq);
    if (seq.length === 0 || target < 0 || target > sorted[seq.length - 1]) {
        return null;
    }
    while (low + 1 < high) {
        const mid = low + ((high - low) >>> 1);
        if (sorted[mid] > target) {
            high = mid;
        }
        else {
            low = mid;
        }
    }
    return low;
}
//# sourceMappingURL=seq.js.map